import { SET_SUBSCRIPTIONS } from '../actions/types';

const initialState = {
	bpoFarm: false,
	premierAgentWebsite: false,
	liveLeads: false,
	dealAnalyzer: false,
	package: "",
	currentPeriodStart: new Date().toJSON(),
	currentPeriodEnd: new Date().toJSON(),
};

const subscriptionReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_SUBSCRIPTIONS:
			return { ...state, ...payload };
		case 'SIGNOUT':
			return initialState;

		default:
			return state;
	}
};

export default subscriptionReducer;
